import { Button } from "primereact/button";
import React, { useRef, useState } from "react";
import { useTranslation } from "react-i18next";

const FileUpload = (props) => {
  const {
    input,
    label,
    type,
    asterisk,
    disabled,
    isSuperAdminShown,
    enableFileDocument,
    meta: { touched, error },
  } = props;
  const { t } = useTranslation("master");
  const fileInputRef = useRef(null);
  const [showFile, setShowFile] = useState(false);
  const handleChange = (e) => {
    const file = e.target.files[0];
    setShowFile(!!file); // Show file controls only if a file is selected
    if (file) {
      input.onChange(file);
    } else {
      input.onChange(null);
    }
    // below line added to select same file again
    e.target.value = null;
  };

  const handleDelete = () => {
    fileInputRef.current.value = "";
    input.onChange("");
    setShowFile(false); // Hide file controls
  };

  const downloadFile = (fileUrl, fileName) => {
    const anchor = document.createElement("a");
    anchor.href = fileUrl;
    anchor.download = fileName || "download";
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
  };

  const handleDownload = () => {
    const fileOrUrl = input.value;

    if (fileOrUrl instanceof File) {
      downloadFile(URL.createObjectURL(fileOrUrl), fileOrUrl.name);
    } else if (typeof fileOrUrl === "string") {
      window.open(fileOrUrl, "_blank");
    }
  };

  const fileName = (() => {
    if (props.value) {
      if (typeof props.value === "string") {
        return props.value.split("/").pop();
      }
      if (props.value instanceof File) {
        return props.value.name;
      }
    }
    if (input.value) {
      if (typeof input.value === "string") {
        return input.value.split("/").pop();
      }
      if (input.value instanceof File) {
        return input.value.name;
      }
    }
    return "";
  })();

  return (
    <>
      <div className="flex-column flex">
        <label className="input-label" htmlFor={input.name}>
          <span className="astoricstyle">{asterisk}</span>
          {t(label)}
        </label>
        <input
          ref={fileInputRef}
          type={type}
          id={input.name}
          accept="image/png,image/jpeg,.doc, .docx,.ppt, .pptx,.txt,.pdf"
          onChange={handleChange}
          disabled={disabled}
          className={
            touched && error
              ? "input-style p-inputtext border-red-500"
              : "input-style p-inputtext"
          }
          style={{ display: "none" }}
        />
        <label
          htmlFor={input.name}
          className={
            touched && error
              ? "input-style p-inputtext flex justify-content-between border-red-500"
              : "input-style p-inputtext flex justify-content-between"
          }
        >
          {fileName || t("Choose File")}
          <i className="pi pi-upload"></i>
        </label>
        <span className="file_format">
          Supported Formats : PNG, JPG, BMP, Emails (.msg & .eml), PDF
        </span>
        {touched && error && <span className="text-red-500">{error}</span>}
      </div>

      {fileName && (
        <div className="gap-2 p-3 flex align-items-center">
          {!enableFileDocument && disabled && isSuperAdminShown && (
            <span>{fileName}</span>
          )}
          {showFile && !disabled && (
            <>
              <span>{fileName}</span>
              <Button
                icon="pi pi-times"
                rounded
                text
                severity="danger"
                aria-label="Remove file"
                tooltip="Remove file"
                onClick={handleDelete}
              />
            </>
          )}
          {isSuperAdminShown && (
            <Button
              icon="pi pi-download"
              rounded
              text
              aria-label="Download file"
              tooltip="Download file"
              onClick={handleDownload}
            />
          )}
        </div>
      )}
    </>
  );
};
export default FileUpload;
